module.exports = __webpack_public_path__ + "img/run_all_icon.2e3194bc.svg";